import React from 'react';
import classnames from 'classnames';
import EntitiesMetricsSummaryBar from '../../EntitiesMetricsSummaryBar';
import DoubleMetricsCompareTableBody from '../DoubleMetricsCompareTableBody';
import type { IBaseProps } from '@/pages/intelligence/types/common';
import type { IEntityFieldsMapping, IEntityMetricFieldsMapping } from '../../../types';
import './index.scss';

interface IMultiMetricsCompareTableBodyProps extends IBaseProps {
  entities: any[];
  entityFieldsMapping: IEntityFieldsMapping;
  periods: string[];
  periodsNamesMapping: {
    [key: string]: string;
  };
  metrics: string[];
  metricsNamesMapping: {
    [key: string]: string;
  };
  metricsNamesTooltipMapping: {
    [key: string]: string;
  };
  metricsMap: {
    [key: string]: any;
  };
  metricFieldsMapping: IEntityMetricFieldsMapping;
  defaultMetricValueFormatter?: (value: any) => any;
  metricValueFormattersMapping?: {
    [key: string]: (value: any) => any;
  };
  periodMaxMetricsMap: {
    [key: string]: any;
  };
  isOpenHeatMap?: boolean;
  showTopCountries?: boolean;
  placeholder?: string;
}

export default function MultiMetricsCompareTableBody(props: IMultiMetricsCompareTableBodyProps) {
  const {
    entities,
    entityFieldsMapping,
    periods,
    periodsNamesMapping,
    metrics,
    metricsNamesMapping,
    metricsNamesTooltipMapping,
    metricsMap,
    metricFieldsMapping,
    defaultMetricValueFormatter,
    metricValueFormattersMapping,
    periodMaxMetricsMap,
    isOpenHeatMap,
    showTopCountries = false,
    placeholder = '-',
    style,
    className,
  } = props;

  return (
    <div
      style={style}
      className={classnames('dbi-entities_table-body dbi-entities_multi-metrics-table-body', className)}
    >
      {metrics?.map((metric) => (
        <React.Fragment key={metric}>
          <EntitiesMetricsSummaryBar
            columns={entities?.length}
            metrics={[metric]}
            metricsNamesMapping={metricsNamesMapping}
            metricsNamesTooltipMapping={metricsNamesTooltipMapping}
            showKeyMetricsWhenOnlyOne={false}
          />
          <DoubleMetricsCompareTableBody
            entities={entities}
            entityFieldsMapping={entityFieldsMapping}
            periods={periods}
            periodsNamesMapping={periodsNamesMapping}
            metrics={[metric]}
            metricsMap={metricsMap}
            metricFieldsMapping={metricFieldsMapping}
            defaultMetricValueFormatter={defaultMetricValueFormatter}
            metricValueFormattersMapping={metricValueFormattersMapping}
            periodMaxMetricsMap={periodMaxMetricsMap}
            isOpenHeatMap={isOpenHeatMap}
            showTopCountries={showTopCountries}
            placeholder={placeholder}
          />
        </React.Fragment>
      ))}
    </div>
  );
}
